import {
  AuditActivityTypeArgs,
  ClindxTableFilterType,
  EMAIL_COLUMN_CLASS,
  FIRST_NAME,
  HEAD_EXSHORT,
  HEAD_MEDIUM,
  HEAD_SHORT,
  OVERFLOW_CONTROL,
  OVERFLOW_CONTROL_CONTENT_WRAP,
  OVERFLOW_CONTROL_PURCHASETABLE,
  PATIENT_NAME
} from './clindx-mat-table.shared';

export const PurchaseOrderGridColumnList = [
  {
    columnName: 'purchaseOrderId',
    columnDisplayValue: 'Order ID',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: true,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 40,
    minLength: 2
  },
  {
    columnName: 'placedOn',
    columnDisplayValue: 'Order Date',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: true,
    type: ClindxTableFilterType.dateRangeType
  },
  {
    columnName: 'firstNameLastNameEmail',
    columnDisplayValue: 'Patient Name (Email)',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    excludeInFilter: true,
    hasSort: true,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2,
    dataAccessor: (row) => {
      return `${row.patientLastName}, ${row.patientFirstName}${row.patientMI ? ', ' + row.patientMI : ''} (${row.patientEmail})`;
    },
  },
  {
    columnName: 'purchaseTest',
    columnDisplayValue: 'Test(s)',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2
  },
  {
    columnName: 'accountName',
    columnDisplayValue: 'Account',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    hasSort: true,
    dataAccessor: (row) => {
      return `${row.accountName} (${row.accountCode})`;
    }
  },
  {
    columnName: 'eventName',
    columnDisplayValue: 'Project',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2
  },
  {
    columnName: 'commercialOrderStatus',
    columnDisplayValue: 'Order Status',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: true,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Order Placed', value: 'OrderPlaced' },
      { name: 'Kit Shipped', value: 'KitShipped' },
      { name: 'Kit Activated', value: 'KitActivated' },
      { name: 'Results Ready', value: 'ResultsReady' }
    ]
  },
  {
    columnName: 'billingType',
    columnDisplayValue: 'Payment Method',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_PURCHASETABLE,
    hasSort: true,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'ClientBill', value: 'ClientBill' },
      { name: 'Insurance', value: 'Insurance' },
      { name: 'SelfPay', value: 'SelfPay' }
    ]
  },
  {
    columnName: 'deliveryMethod',
    columnDisplayValue: 'Delivery Method',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_PURCHASETABLE,
    hasSort: true,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Uber', value: 'Uber' },
      { name: 'FedEx', value: 'FedEx' }
    ]
  },
  {
    columnName: 'totalPriceValue',
    columnDisplayValue: 'Total Order Amount',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_PURCHASETABLE,
    hasSort: true,
    dataAccessor: (row) => {
      return `$${row.totalPrice}`;
    },
  },
  {
    columnName: 'purchaseActions',
    columnDisplayValue: 'Actions',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false
  },
  {
    columnName: 'email',
    columnDisplayValue: 'Email',
    includeInFilter: true,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2
  },
  {
    columnName: 'patientName',
    columnDisplayValue: PATIENT_NAME,
    includeInFilter: true,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2
  }
];

export const PurchaseOrderForPatientColumnList = [
  {
    columnName: 'purchaseOrderId',
    columnDisplayValue: 'Order ID',
    classThName: 'head-medium overflow-control',
    classTdName: OVERFLOW_CONTROL,
    hasSort: false
  },
  {
    columnName: 'placedOn',
    columnDisplayValue: 'Order Date',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    hasSort: true
  },
  {
    columnName: 'purchaseTestForPatient',
    columnDisplayValue: 'Test(s)',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    hasSort: true
  },
  {
    columnName: 'eventNameaccountName',
    columnDisplayValue: 'Project (Account)',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    dataAccessor: (row) => {
      return (row.eventName) ?
        `${row.eventName} (${row.accountName})`
        : `(${row.accountName})`;
    },
  },
  {
    columnName: 'commercialOrderStatus',
    columnDisplayValue: 'Order Status',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    hasSort: true
  },
  {
    columnName: 'specimenKitIdForPurchaseOrder',
    columnDisplayValue: 'Kit ID',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false
  },
  {
    columnName: 'billingType',
    columnDisplayValue: 'Payment Method',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false
  },
  {
    columnName: 'deliveryMethod',
    columnDisplayValue: 'Delivery Method',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false
  },
  {
    columnName: 'totalPriceValue',
    columnDisplayValue: 'Total Order Amount',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    dataAccessor: (row) => {
      return `$${row.totalPrice}`;
    },
  }
];

export const OrderConfirmationTestSpecimensColumnList = [
  {
    columnName: 'testName',
    columnDisplayValue: 'Applicable Test(s)',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'applicableSpecimen',
    columnDisplayValue: 'Applicable Specimen',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
];

export const AccountListTableColumns = [
  {
    columnName: 'buName',
    columnDisplayValue: 'BU',
    classThName: '',
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'accountName',
    columnDisplayValue: 'Account Name',
    classThName: '',
    classTdName: '',
    hasSort: false,
  },
  {
    columnName: 'accountCode',
    columnDisplayValue: 'BU Account code',
    classThName: '',
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: '',
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Active', value: 'Active' },
      { name: 'Inactive', value: 'Inactive' }
    ]
  },
  {
    columnName: 'accountsAction',
    columnDisplayValue: 'Action',
    classThName: '',
    classTdName: '',
    hasSort: false
  }
];

export const PhysicianRegistryColumns = [
  {
    columnName: 'actions',
    columnDisplayValue: 'Select',
    classThName: HEAD_SHORT,
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'npiNumber',
    columnDisplayValue: 'Npi Number',
    classThName: '',
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'firstName',
    columnDisplayValue: FIRST_NAME,
    classThName: '',
    classTdName: '',
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'lastName',
    columnDisplayValue: 'Last Name',
    classThName: '',
    classTdName: '',
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'addressLine1',
    columnDisplayValue: 'Address Line1',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'addressLine2',
    columnDisplayValue: 'Address Line2',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'city',
    columnDisplayValue: 'City',
    classThName: '',
    classTdName: '',
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'zipCode',
    columnDisplayValue: 'Zip Code',
    classThName: '',
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'stateCode',
    columnDisplayValue: 'State Code',
    classThName: '',
    classTdName: '',
    hidden: true,
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'stateName',
    columnDisplayValue: 'State',
    classThName: '',
    classTdName: ''
  },
  {
    columnName: 'country',
    columnDisplayValue: 'Country',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'phone',
    columnDisplayValue: 'Phone',
    classThName: '',
    classTdName: '',
    hasSort: false
  }
];

export const RequisitionManifestSpecimensColumnList = [
  {
    columnName: 'specimenId',
    columnDisplayValue: 'Specimen ID',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'specimenType',
    columnDisplayValue: 'Specimen Type',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'specimenSource',
    columnDisplayValue: 'Specimen Source',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'collectionDateAndTime',
    columnDisplayValue: 'Collection Date/Time',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'CentrifugeDateAndTime',
    columnDisplayValue: 'Centrifuge Date/Time',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'RefrigeratedDateAndTime',
    columnDisplayValue: 'Refrigerated Date/Time',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'FrozenDateAndTime',
    columnDisplayValue: 'Frozen Date/Time',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'clientId',
    columnDisplayValue: 'Client ID',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'donorType',
    columnDisplayValue: 'Donor Type',
    classThName: '',
    classTdName: '',
    hasSort: false
  }
];

export const BulkOrderUploadValidationErrorColumnList = [
  {
    columnName: 'index',
    columnDisplayValue: 'Index',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    columnWidth: '2%',
    hasSort: false
  },
  {
    columnName: 'error',
    columnDisplayValue: 'Error',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false
  }
];

export const BulkOrderUploadAuditLogColumnList = [
  {
    columnName: 'fileName',
    columnDisplayValue: 'FileName',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '12%',
    hasSort: false
  },
  {
    columnName: 'totalOrders',
    columnDisplayValue: 'TotalOrders',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '2%',
    hasSort: false
  },
  {
    columnName: 'createdDatetime',
    columnDisplayValue: 'CreatedDatetime',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '10%',
    hasSort: false
  },
  {
    columnName: 'email',
    columnDisplayValue: 'Email',
    classThName: HEAD_SHORT,
    classTdName: EMAIL_COLUMN_CLASS,
    columnWidth: '15%',
    hasSort: false
  },
  {
    columnName: 'statusValue',
    columnDisplayValue: 'Status',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '8%',
    hasSort: false
  },
  {
    columnName: 'remarks',
    columnDisplayValue: 'Remarks',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    hasSort: false
  }
];

export const PayorsTableColumnList = [
  {
    columnName: 'payorId',
    columnDisplayValue: 'Payor ID',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    minLength: 2,
    hasSort: true
  },
  {
    columnName: 'payorName',
    columnDisplayValue: 'Payor Name',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: true
  },
  {
    columnName: 'payorGroup',
    columnDisplayValue: 'Payor Group',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    minLength: 2,
    hasSort: true
  },
  {
    columnName: 'category',
    columnDisplayValue: 'Category',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    minLength: 2,
    hasSort: false
  },
  {
    columnName: 'contactAddress',
    columnDisplayValue: 'Contact Address',
    classThName: 'head-long',
    classTdName: '',
    dataAccessor: (row) => {
      return [row.addressLine1, row.addressLine2, row.city, row.stateCode, row.zipCode, row.phone]
        .filter((val: string) => val?.toString().length).join(', ');
    },
    hasSort: false
  },
  {
    columnName: 'buCode',
    columnDisplayValue: 'BU',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    minLength: 2,
    hasSort: true
  },
  {
    columnName: 'IsActive',
    columnDisplayValue: 'Status',
    classThName: HEAD_SHORT,
    classTdName: '',
    dataAccessor: (row) => {
      return row.isActive ? 'Active': 'Inactive';
    },
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Active', value: 'active' },
      { name: 'Inactive', value: 'inactive' }
    ],
    hasSort: false
  },
  {
    columnName: 'actionsForPayors',
    columnDisplayValue: 'Actions',
    classThName: HEAD_EXSHORT,
    classTdName: '',
    hasSort: false
  }
];

export const AuditLogsTableColumnList = [
  {
    columnName: 'sessionId',
    columnDisplayValue: 'Session ID',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    hasSort: false,
    columnWidth: '15%'
  }, {
    columnName: 'userId',
    columnDisplayValue: 'User ID',
    classThName: HEAD_EXSHORT,
    classTdName: 'overflow-control-word-break-all',
    type: ClindxTableFilterType.inputType,
    hasSort: false,
    columnWidth: '15%'
  }, {
    columnName: 'timeStamp',
    columnDisplayValue: 'Timestamp',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.dateRangeType,
    hasSort: true,
    columnWidth: '15%'
  }, {
    columnName: 'ipAddress',
    columnDisplayValue: 'IP Address',
    classThName: HEAD_EXSHORT,
    classTdName: 'overflow-control-word-break-all',
    type: ClindxTableFilterType.inputType,
    hasSort: false,
    columnWidth: '10%'
  }, {
    columnName: 'activityType',
    columnDisplayValue: 'Activity Type',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.enumType,
    args: AuditActivityTypeArgs,
    isMulti: true,
    hasSort: false,
    columnWidth: '15%'
  }, {
    columnName: 'activityDetail',
    columnDisplayValue: 'Activity Details',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    type: ClindxTableFilterType.inputType,
    excludeInFilter: true,
    hasSort: false,
    columnWidth: '30%',
    id : 'UserActivityLogActivityDetails'
  }
];